/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { FETCH_LOCATIONS_REQUEST, FETCH_LOCATIONS_SUCCESS, FETCH_LOCATIONS_FAILURE } from './types';
import { ILocations, IPage, pageData } from "../../container/Locations/constants";

export const initialState: {
  locations: ILocations[];
  page: IPage;
  loading: boolean;
  error: null;
} = {
  locations: [],
  page: pageData,
  loading: false,
  error: null
};

export const locationsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case FETCH_LOCATIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_LOCATIONS_SUCCESS:
      return {
        ...state,
        locations: action.locations,
        page: action.page,
        loading: false,
        error: null
      };

    case FETCH_LOCATIONS_FAILURE:
      return {
        ...state,
        locations: [],
        page: pageData,
        loading: false,
        error: action.error
      };
    default:
      return state;
  }
};
